import { freddyTheme } from '@coolblue-development/freddy';
export const getNavigationMenuGroupsStyles = ({ hasVisibleNavigationGroup, }) => ({
    width: 'var(--cb-category-navigation-menugroup-width)',
    listStyleType: 'none',
    background: freddyTheme.color.background.base,
    borderRadius: `0 0 ${freddyTheme.borderRadius[100]} ${freddyTheme.borderRadius[100]}`,
    '&::before': {
        borderRadius: `0 0 ${freddyTheme.borderRadius[100]} ${freddyTheme.borderRadius[100]}`,
        boxShadow: `0 0.1rem 0.5rem ${freddyTheme.color.border.tertiary}`,
        content: '""',
        height: '100%',
        opacity: hasVisibleNavigationGroup ? 0 : 1,
        position: 'absolute',
        top: 0,
        left: 0,
        width: 'var(--cb-category-navigation-menugroup-width)',
        zIndex: -1,
    },
});
export const getNavigationMenuGroupButtonStyles = ({ isActive, }) => ({
    all: 'unset',
    outline: 'revert',
    boxSizing: 'border-box',
    position: 'relative',
    zIndex: 7,
    padding: `${freddyTheme.spacing[200]} !important`,
    fontSize: freddyTheme.typography.fontSize.lg,
    width: '100%',
    color: freddyTheme.color.font.interactiveBase,
    ...(isActive && {
        background: freddyTheme.color.background.interactiveHovered,
    }),
    '&:hover, &:focus': {
        boxShadow: 'none',
        background: freddyTheme.color.background.interactiveHovered,
    },
});
export const getNavigationCategoriesStyles = ({ isOpen }) => ({
    position: 'absolute',
    top: 0,
    left: 0,
    padding: `${freddyTheme.spacing[600]} ${freddyTheme.spacing[600]} 0 calc(var(--cb-category-navigation-menugroup-width) + ${freddyTheme.spacing[600]})`,
    width: '100%',
    backgroundColor: freddyTheme.color.background.base,
    display: isOpen ? 'block' : 'none',
    zIndex: 6,
    minHeight: '100%',
    columns: 2,
    whiteSpace: 'normal',
    columnGap: freddyTheme.spacing[1000],
    [freddyTheme.breakpoint.minWidth('lg')]: {
        columns: 4,
    },
    '&::before': {
        content: '""',
        position: 'absolute',
        left: 'var(--cb-category-navigation-menugroup-width)',
        top: 0,
        zIndex: -1,
        height: '100%',
        borderLeft: `${freddyTheme.borderWidth[25]} solid ${freddyTheme.color.border.base}`,
    },
    '&::after': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        zIndex: -1,
        height: '100%',
        boxShadow: `0 0.1rem 0.5rem ${freddyTheme.color.border.tertiary}`,
        borderRadius: `0 0 ${freddyTheme.borderRadius[100]} ${freddyTheme.borderRadius[100]}`,
    },
});
//# sourceMappingURL=CategoryNavigationDropdown.styles.js.map